/**
 * This file holds some random logic and is full of undefined behavior
 * it's sole existance is to initialize all connections we could have
 * for the runtime of the application.
 */
import { STR_ERRORS } from "../Strings";
import { InternalMessageBusChannels } from "sb-internal-msg-bus";
import { onTokenRenew } from "../Network";
import { ConfigStore, ConnectionNames } from "../Stores";
import { sportsSocketConnectionHandlers } from "./sportsSocketConnectionHandlers";
import { WCConnectionsFactory } from "./WCConnectionsFactory";
export const WCHandlers = {
    [ConnectionNames.sports]: sportsSocketConnectionHandlers,
    [ConnectionNames.betslip]: {}
};
// TODO: mock E2E execution including updates
export function init(config) {
    if (typeof config.msgBus !== "object" || typeof config.msgBus.on !== "function") {
        throw new Error(STR_ERRORS.NoMessageBus);
    }
    // Imports are read-only and that's why we use an object's property
    ConfigStore.config = Object.assign(Object.assign({}, ConfigStore.config), config);
    if (Object.keys(ConfigStore.config.urls).length === 0) {
        throw new Error(STR_ERRORS.NoConnectionUrls);
    }
    // TODO: pass url for connection once we have the token
    // TODO: define no token flow... we can't connect - so? => throw
    ConfigStore.config.msgBus.on(InternalMessageBusChannels.legacy.platformJWTChange.renewJWTToken, onTokenRenew);
    Object
        .keys(ConfigStore.config.urls)
        .forEach(x => WCConnectionsFactory[x](ConfigStore.config.urls[x]));
}
//# sourceMappingURL=App.js.map